type BranchLike = { id?: number | string, title?: string | null };
type EditedBranchLike = { id?: number | string } | null | undefined;
type FormPayloadLike = { title?: string | null };

// Substitutes the edited branch's persisted title with its unsaved form value
// so an in-flight rename still occupies the slot for collision resolution.
export function collectExistingTitles(
  branches: BranchLike[] | undefined | null,
  editedBranch: EditedBranchLike,
  formPayload: FormPayloadLike,
): string[] {
  if (!Array.isArray(branches)) return [];
  const editedId = editedBranch?.id;
  const formTitle = typeof formPayload?.title === 'string' ? formPayload.title : '';
  return branches
    .map((b) => {
      if (editedId !== undefined && b?.id === editedId) {
        return formTitle || b?.title || '';
      }
      return b?.title ?? '';
    })
    .filter((t) => typeof t === 'string' && t.length > 0);
}
